import RecommendationsPrintout from "./RecommendationsPrintout";

export default RecommendationsPrintout;
